import { render, staticRenderFns } from "./VideoModel.vue?vue&type=template&id=69b3195a&scoped=true&"
import script from "./VideoModel.vue?vue&type=script&lang=js&"
export * from "./VideoModel.vue?vue&type=script&lang=js&"
import style0 from "./VideoModel.vue?vue&type=style&index=0&id=69b3195a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b3195a",
  null
  
)

export default component.exports